import { defineStore } from 'pinia'

interface Transaction {
  current_balance: number
  amount: number
  order_id: string | null
  comments: string | null
  associated_uid: string
  created_at: number
}

interface TransactionState {
  transactions: Transaction[]
  total: number
}

export const useTransactionStore = defineStore('transaction', {
  state: (): TransactionState => ({
    transactions: [],
    total: 0,
  }),

  actions: {
    setTransactions(transactions: Transaction[], total: number) {
      this.transactions = transactions
      this.total = total
      // 保存到 localStorage
      localStorage.setItem('transactions', JSON.stringify(transactions))
      localStorage.setItem('transactions_total', total.toString())
    },

    getTransactions(): Transaction[] {
      // 如果 store 为空，尝试从 localStorage 恢复数据
      if (this.transactions.length === 0) {
        const savedTransactions = localStorage.getItem('transactions')
        if (savedTransactions) {
          this.transactions = JSON.parse(savedTransactions)
        }
      }
      return this.transactions
    },

    clearTransactions() {
      this.transactions = []
      this.total = 0
      // 清除 localStorage 中的数据
      localStorage.removeItem('transactions')
      localStorage.removeItem('transactions_total')
    },
  },
})
